import {
  Alert,
  Button, Checkbox, CircularProgress, FormControlLabel, Grid, IconButton, Stack, Tooltip, Typography
} from "@mui/material";
import { ScrollableDialogProps } from "../Dialogs";
import ButtonFileComponente from "../ButtonFileComponente";
import {
  filasManualesLimpias,
  permiteIngresoManual,
  topeSeriesManual,
  useCargarSeriesProductos,
  usaMetrosPorSerie,
} from "@/store/erp/productos/useCargarSeriesProductos.store";
import { Delete, Download, ErrorOutline, InfoOutlined } from "@mui/icons-material";
import SampleTable from "../SampleTable";
import { useTableColumnsProducto, useUploadFile } from "@/shared/hooks";
import { getEnvs } from "@/shared/utils";
import { gridSizeMdLg4, plantillaExcelENUM } from "@/shared/constants";
import { useState } from "react";
import CargaManualSeries from "./CargaManualSeries";
//import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

import {
  MaterialTransferido,
  SerieGeneradoPorENUM
} from "@/shared/interfaces";
import { openGenericObjectModal } from "../ModalGenericObject/useGenericObjectModalStore";
import { fieldSeries } from "@/shared/utils/fields-modal-generic-object";

const { VITE_API_URL_AWS } = getEnvs();
interface ModalProductoSeriesProps {
  generarSerie?: boolean
  seleccionarAutomatico?: boolean
  seleccionarManual?: boolean
  size?: {
    xs: number;
    sm: number;
    md: number;
    lg: number;
  };
  enableActionManual?: boolean
  keyCant?: keyof MaterialTransferido
}

export default function ModalProductoSeries({
  seleccionarAutomatico = false,
  seleccionarManual = false,
  //generarSerie = true,
  size = gridSizeMdLg4,
  //enableActionManual = true,
  //keyCant = 'cantidad'
}: ModalProductoSeriesProps) {

  const openModalSeries = useCargarSeriesProductos(s => s.openModalSeries)
  const setOpenModalSeries = useCargarSeriesProductos(s => s.setOpenModalSeries)
  const auxRow = useCargarSeriesProductos(s => s.auxRow)
  const setAuxRow = useCargarSeriesProductos(s => s.setAuxRow)
  const handleFileExcel = useCargarSeriesProductos(s => s.handleFileExcel)
  const handleFileTxt = useCargarSeriesProductos(s => s.handleFileTxt)
  //const handleGenerarSeries = useCargarSeriesProductos(s => s.handleGenerarSeries)
  const handleActualizarProducto = useCargarSeriesProductos(s => s.handleActualizarProducto)
  const handleSelectSeriesAutomatico = useCargarSeriesProductos(s => s.handleSelectSeriesAutomatico)
  const esProductoFactor = useCargarSeriesProductos(s => s.esProductoFactor)
  const validarSeriesDuplicadas = useCargarSeriesProductos(s => s.validarSeriesDuplicadas)
  const modoValidacion = useCargarSeriesProductos(s => s.modoValidacion)
  // Validación de series duplicadas
  const seriesDuplicadas = useCargarSeriesProductos(s => s.seriesDuplicadas)
  const totalDuplicadas = useCargarSeriesProductos(s => s.totalDuplicadas)
  const isValidandoSeries = useCargarSeriesProductos(s => s.isValidandoSeries)
  const limpiarSeriesDuplicadas = useCargarSeriesProductos(s => s.limpiarSeriesDuplicadas)
  const {
    columnsCargarSeries,
    columnsProductoFactorRecepcion,
    columnsProductMetroSeries
  } = useTableColumnsProducto()
  const [visibleSeriesManual, setvisibleSeriesManual] = useState<boolean>(false)
  ///* null = el usuario no lo toco en esta apertura del modal.
  const [reingresoElegido, setReingresoElegido] = useState<boolean | null>(null)

  // Determinar si hay series duplicadas
  const tieneDuplicados = totalDuplicadas > 0

  const esMetros = usaMetrosPorSerie(auxRow)
  const cargadas = auxRow?.series?.length ?? 0
  const esCargaManual = auxRow?.serie_generado_por === SerieGeneradoPorENUM.SELECCION_MANUAL

  ///* Reingreso: habilita la carga manual. Sin tocarlo, se deduce de las series
  ///* ya cargadas, asi al reabrir un producto cargado a mano sigue marcado.
  const muestraReingreso = seleccionarManual && permiteIngresoManual(auxRow)
  const esReingreso = reingresoElegido ?? (cargadas > 0 && esCargaManual)
  const ofreceManual = muestraReingreso && esReingreso

  ///* Por cantidad: series == cantidad, al cargar el archivo y al guardar. Solo
  ///* en el ingreso; las demas pantallas validan contra su propia cantidad.
  const tope = topeSeriesManual(auxRow)
  const exigeCantidadExacta = seleccionarManual && !esProductoFactor && tope > 0
  const cantidadNoCuadra = exigeCantidadExacta && cargadas !== tope
  const opcionesArchivo = exigeCantidadExacta ? { maxSeries: tope } : undefined

  ///* Cambiar de metodo cambia el origen de las series, del que se deduce el
  ///* checkbox: se fija el valor que el usuario esta viendo.
  const fijarReingreso = () => {
    if (reingresoElegido === null) setReingresoElegido(esReingreso)
  }

  const limpiarSeries = () => {
    limpiarSeriesDuplicadas();
    setAuxRow({
      ...auxRow!,
      series: [],
      selected_series: [],
      file_temporal: null,
      ...filasManualesLimpias(auxRow, esProductoFactor),
    });
  }

  const handleCambiarReingreso = (marcado: boolean) => {
    ///* Sin el boton manual, las series cargadas a mano no se podrian corregir.
    if (!marcado) {
      setvisibleSeriesManual(false)
      if (esCargaManual && cargadas > 0) limpiarSeries()
    }
    setReingresoElegido(marcado)
  }

  const {
    descargarExcelUrl,
    descargarTxtDesdeUrl
  } = useUploadFile();

  const handleLimpiarComponente = () => {
    setAuxRow(null);
    setOpenModalSeries(false);
    setvisibleSeriesManual(false);
    setReingresoElegido(null);
    limpiarSeriesDuplicadas();
  }

  /* function handleDescargarArchivo(value: string) {
    switch (value) {
      case SerieGeneradoPorENUM.TXT:
        descargarTxtDesdeUrl(auxRow?.url_archivo);
        break;
      case SerieGeneradoPorENUM.EXCEL:
        descargarExcelUrl(auxRow?.url_archivo);
        break;
      default:
        break;
    }
  } */

  return (
    <ScrollableDialogProps
      minWidth="60%"
      onCloseIcon={() => {
        handleLimpiarComponente()
      }}
      open={openModalSeries}
      title={`Cargar Series: ${auxRow?.codigo}`}
      dialogContentText={'Seleccionar una opción para cargar series.'}
      onConfirm={async () => {
        // No permitir guardar si hay series duplicadas
        if (tieneDuplicados || cantidadNoCuadra) return;

        ///* Las series manuales se validaron al agregarlas, pero otro usuario
        ///* pudo ingresarlas entre tanto: se revalida la lista antes de guardar.
        if (esCargaManual && modoValidacion !== 'traslado' && auxRow?.codigo && cargadas > 0) {
          const hayDuplicadas = await validarSeriesDuplicadas(auxRow.codigo, auxRow.series ?? [], { bloquearEnError: true })
          if (hayDuplicadas) return;
        }

        handleActualizarProducto(auxRow?.id!, {
          ...auxRow,
          ///* Por metros cada carrete es una unidad: el ingreso exige
          ///* series.length == cantidad y el backend calcula metros_base * cantidad.
          ...(seleccionarManual && esMetros && cargadas > 0 && { cantidad: String(cargadas) }),
          file_temporal: auxRow?.file_temporal
        })
        handleLimpiarComponente();

      }}
      confirmTextBtn={isValidandoSeries ? "Validando..." : "Guardar"}
      confirmVariantBtn="outlined"
      confirmDisabled={tieneDuplicados || cantidadNoCuadra || isValidandoSeries}
      contentNode={
        <Grid container spacing={2}>
          {muestraReingreso && (
            <Grid item xs={12}>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={esReingreso}
                    onChange={(e) => handleCambiarReingreso(e.target.checked)}
                  />
                }
                label={
                  <Stack direction="row" alignItems="center" spacing={0.5}>
                    <span>Reingreso</span>
                    <Tooltip title="Habilita la carga manual de series.">
                      <InfoOutlined fontSize="small" color="action" />
                    </Tooltip>
                  </Stack>
                }
              />
              <Typography variant="caption" color="text.secondary" component="div" sx={{ ml: 4 }}>
                Marque esta opción si es un reingreso, para habilitar la carga manual.
              </Typography>
            </Grid>
          )}

          <Grid item {...size} container>
            <Grid item xs={11}>
              <ButtonFileComponente
                color={'success'}
                accept={".txt"}
                onChange={event => {
                  fijarReingreso();
                  setvisibleSeriesManual(false);
                  handleFileTxt(event, opcionesArchivo);
                }}
                titulo={"Cargar TXT"} />
            </Grid>
            <Grid item xs={1}>
              <Tooltip placement="top" title='Descargar plantilla'>
                <IconButton
                  onClick={() => descargarTxtDesdeUrl(`${VITE_API_URL_AWS}/test${plantillaExcelENUM.PLANTILLA_SERIE_TXT}`, 'plantilla_serie_txt.txt')} ///*TODO: Cambiar el bucket a prod
                >
                  <Download />
                </IconButton>
              </Tooltip>
            </Grid>
          </Grid>

          <Grid item {...size} container>
            <Grid item xs={11}>
              <ButtonFileComponente
                color={'success'}
                accept={".xls, .xlsx"}
                onChange={event => {
                  fijarReingreso();
                  setvisibleSeriesManual(false)
                  handleFileExcel(event, opcionesArchivo)
                }}
                titulo={"Cargar EXCEL"} />
            </Grid>
            <Grid item xs={1}>
              <Tooltip placement="top" title='Descargar plantilla'>
                <IconButton
                  onClick={() => descargarExcelUrl(`${VITE_API_URL_AWS}/test${plantillaExcelENUM.PLANTILLA_SERIE_EXCEL}`, 'plantilla_serie_excel.xlsx')}
                >
                  <Download />
                </IconButton>
              </Tooltip>
            </Grid>

          </Grid>

          {/*Generar series por el backend*/}

          {/* {
            generarSerie && (
              <Grid item {...size}>
                <Button
                  variant="contained"
                  component="span"
                  fullWidth
                  size="small"
                  style={{
                    color: 'white',
                    background: 'black'
                  }}
                  onClick={() => {
                    setvisibleSeriesManual(false);
                    //handleGenerarSeries('cantidad_recibida');
                    handleGenerarSeries(keyCant);

                  }}
                >
                  Generar Automatico
                </Button>
              </Grid>
            )
          } */}

          {/*Seleccionar series automatico por el sistema*/}
          {
            seleccionarAutomatico && (
              <Grid item {...size}>
                <Button size="small"
                  style={{
                    color: 'white',
                    background: 'black'
                  }}

                  onClick={() => {
                    setvisibleSeriesManual(false);
                    handleSelectSeriesAutomatico();
                  }}
                  fullWidth variant="contained">
                  AUTOMATICO
                </Button>
              </Grid>
            )
          }

          {/*Seleccionar series por el usuario*/}

          {
            ofreceManual && (
              <Grid item {...size}>
                <Button
                  fullWidth
                  size="small"
                  style={{
                    color: 'white',
                    background: 'black'
                  }}
                  variant='contained'
                  onClick={() => {
                    ///* No reinicia la lista: las series de TXT/Excel se
                    ///* conservan y las manuales se agregan a ellas.
                    fijarReingreso();
                    setvisibleSeriesManual(true)
                  }}
                >
                  {'Cargar Manualmente'}
                </Button>
              </Grid>
            )
          }

          {/* Indicador de validación en progreso */}
          {isValidandoSeries && (
            <Grid item xs={12}>
              <Alert severity="info" icon={<CircularProgress size={20} />}>
                Validando series duplicadas...
              </Alert>
            </Grid>
          )}

          {/* Alerta de series duplicadas */}
          {tieneDuplicados && !isValidandoSeries && (
            <Grid item xs={12}>
              <Alert
                severity="error"
                icon={<ErrorOutline />}
                onClose={() => {
                  limpiarSeriesDuplicadas();
                  setAuxRow({
                    ...auxRow!,
                    series: [],
                    file_temporal: null
                  });
                }}
              >
                <Typography variant="body2" fontWeight="bold">
                  Se encontraron {totalDuplicadas} series duplicadas
                </Typography>
                <Typography variant="caption" component="div">
                  Las siguientes series ya existen en el sistema para este producto:
                </Typography>
                <Typography variant="caption" component="div" sx={{ mt: 0.5, fontFamily: 'monospace' }}>
                  {seriesDuplicadas.slice(0, 10).join(', ')}
                  {/*{seriesDuplicadas.length > 10 && ` ... y ${seriesDuplicadas.length - 10} más`}*/}
                  <Button

                    onClick={() => {

                      openGenericObjectModal({
                        data: {
                          series: seriesDuplicadas.join(', ')
                        },
                        fields: fieldSeries,
                        title: "Series Duplicadas",
                        emptyFallback: "—",
                      });

                      // TODO: Implementar visualización completa de series
                      //console.log('Mostrar todas las series duplicadas');

                    }}
                  >
                    ... VER MÁS
                  </Button>
                </Typography>
                <Typography variant="caption" component="div" sx={{ mt: 1, fontStyle: 'italic' }}>
                  Por favor, corrija el archivo y vuelva a cargarlo.
                </Typography>
              </Alert>
            </Grid>
          )}

          {/*Renderizar componente para seleccionar manualmente las series*/}

          {visibleSeriesManual && ofreceManual && (
            <Grid item xs={12}>
              <CargaManualSeries />
            </Grid>
          )}


          {/*Series cargadas: se ven siempre, tambien durante la carga manual*/}
          {
            <Grid container item xs={12}>

              <Grid item xs={11}>
                <Typography variant="overline">Series:</Typography>
              </Grid>
              <Grid item xs={1}>
                <Tooltip title='Limpiar' >
                  <IconButton onClick={limpiarSeries}>
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Grid>

              {/* {
                auxRow?.series
                && auxRow?.series?.length > 0 && (
                  <Alert
                    iconMapping={{
                      success: <CheckCircleOutlineIcon fontSize="inherit" />
                    }}
                  >
                    {`Se generó por ${auxRow.serie_generado_por} la cantidad de ${auxRow?.series?.length} series con éxito.`}
                  </Alert>
                )
              } */}

              {/* {
                auxRow?.producto_factor?.length != 0
                  ? (
                    <Grid item xs={12}>
                      <SampleTable<any>
                        density="compact"
                        columns={columnsProductoFactorRecepcion}
                        data={auxRow?.producto_factor || []}
                        enablePagination={true}
                      />
                    </Grid>
                  )
                  : (
                    <Grid item xs={12}>
                      <SampleTable<any>
                        density="compact"
                        columns={columnsCargarSeries}
                        data={auxRow?.series || []}
                        enablePagination={true}
                      />
                    </Grid>
                  )
              } */}

              {/* <Grid item xs={12}>
                <SampleTable<any>
                  density="compact"
                  columns={columnsCargarSeries}
                  data={auxRow?.series || []}
                  enablePagination={true}
                />
              </Grid> */}
              {
                auxRow?.series && !!auxRow.series.length && (
                  <>
                    {
                      auxRow.serie_generado_por == SerieGeneradoPorENUM.TXT ||
                        auxRow.serie_generado_por == SerieGeneradoPorENUM.EXCEL ||
                        !auxRow?.producto_factor?.length
                        ?
                        (
                          <Grid item xs={12}>
                            <SampleTable<any>
                              density="compact"
                              columns={columnsCargarSeries}
                              data={auxRow?.series || []}
                              enablePagination={true}
                            />
                          </Grid>
                        )
                        :
                        (

                          <Grid item xs={12}>
                            <SampleTable<any>
                              density="compact"
                              columns={esMetros && esCargaManual ? columnsProductMetroSeries : columnsProductoFactorRecepcion}
                              data={auxRow?.producto_factor || []}
                              enablePagination={true}
                            />
                          </Grid>

                        )
                    }
                  </>
                )
              }

              {/* {
                (auxRow?.serie_generado_por == SerieGeneradoPorENUM.TXT ||
                  auxRow?.serie_generado_por == SerieGeneradoPorENUM.EXCEL)
                && auxRow.url_archivo && (
                  <Grid item xs={12}>
                    <Alert
                      severity="success"
                      action={
                        <Button color="inherit" size="small"
                          onClick={() => {
                            handleDescargarArchivo(auxRow?.serie_generado_por ?? '');
                          }}
                        >
                          DESCARGAR
                        </Button>
                      }
                    >
                      SERIES CARGADO POR {auxRow?.serie_generado_por}
                    </Alert>
                  </Grid>
                )
              } */}

            </Grid>
          }

          {cantidadNoCuadra && (
            <Grid item xs={12}>
              <Alert severity="warning">
                {cargadas < tope
                  ? `Faltan ${tope - cargadas} serie(s) para poder guardar (${cargadas} / ${tope}).`
                  : `Sobran ${cargadas - tope} serie(s): la cantidad es ${tope}.`}
              </Alert>
            </Grid>
          )}

          {/* {!visibleSeriesManual && (
            <Grid container item xs={12}>
              <Grid item xs={11}>
                <Typography variant="overline">Series:</Typography>
              </Grid>
              <Grid item xs={1}>
                <Tooltip title='Limpiar' >
                  <IconButton
                    onClick={() => {
                      setAuxRow({
                        ...auxRow!,
                        series: [],
                        selected_series: [],
                        file_temporal: null
                      });
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Tooltip>
              </Grid>
              <Grid item xs={12}>
                <SampleTable<any>
                  density="compact"
                  columns={columnsCargarSeries}
                  data={auxRow?.series || []}
                  enablePagination={true}
                />
              </Grid>
            </Grid>
          )} */}

        </Grid>
      }
    />
  )

}